"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.liveStatusMapper = void 0;
const enum_mapper_1 = require("../../utils/enum-mapper");
const globalTypes_1 = require("../generated/globalTypes");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
exports.liveStatusMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.LiveStatus.DVR_PROCESSING]: api_types_1.ItemType.ItemLiveFinalize,
    [globalTypes_1.LiveStatus.SCHEDULED]: api_types_1.ItemType.ItemScheduled,
    [globalTypes_1.LiveStatus.STREAMING]: api_types_1.ItemType.ItemLive,
    [globalTypes_1.LiveStatus.FINISHED]: api_types_1.ItemType.ItemLiveFinalize,
    [globalTypes_1.LiveStatus.EXPIRED]: api_types_1.ItemType.ItemLiveFinalize,
    [globalTypes_1.LiveStatus.PENDING]: api_types_1.ItemType.ItemLive,
    [globalTypes_1.LiveStatus.RECONNECTING]: api_types_1.ItemType.ItemLive,
});
//# sourceMappingURL=live-status.js.map